import { Result } from '@core/models/common.model';

// Extract array safely
export function extractContent<T>(response: Result<{ content: T[] }>): T[] {
  if (response.success) {
    return Array.isArray(response.data?.content) ? response.data.content : [];
  }
  return [];
}

// Extract single object safely
export function extractResponse<T>(response: Result<T>): T | null {
  return response.success ? response.data : null;
}

// Extract nested lists (useful for master data dropdowns)
export function extractList<T>(
  response: Result<any>,
  key: string
): T[] {
  if (response.success && Array.isArray(response.data?.[key])) {
    return response.data?.[key].map((item: any) => ({
      label: item.label,
      value: item.value,
    })) as unknown as T[];
  }
  return [];
}
